import React from "react";
import ReactDOM from "react-dom";

import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";

import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import store from "./store/index";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://8f7194a838df6ce38d6654ed257d87e2@o4507571489210368.ingest.de.sentry.io/4508992589725776",
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0
  });
}

ReactDOM.render(
  <Provider store={store}>
    <Sentry.ErrorBoundary
      fallback={
        <div className="d-flex flex-column align-items-center justify-content-center text-danger py-10">
          <div className="fw-bold text-center fs-1">
            Something went wrong. Please try again later. 🚨
          </div>
        </div>
      }
    >
      <ToastContainer />
      <App />
    </Sentry.ErrorBoundary>
  </Provider>,
  document.getElementById("root")
);
